import React, { useState, useEffect } from 'react';

import { useTranslation } from 'next-i18next';
// import PropTypes from 'prop-types';
import { basePageWrap } from '../BasePage';
import HeroBackground from '../../components/HeroBackground';
import WhatWeOfferModule from '../../components/WhatWeOfferModule';
import s from './WhatWeOfferCategoryPage.module.scss';

const WhatWeOfferCategoryPage = ({
  title = {},
  preamble,
  pages,
  image,
  isDesktop,
}) => {
  return (
    <div className={s.Root}>
      <HeroBackground />
      <WhatWeOfferModule
        title={title}
        preamble={preamble}
        pages={pages}
        image={image}
        isDesktop={isDesktop}
      />
    </div>
  );
};

export default basePageWrap(WhatWeOfferCategoryPage);
